export enum familyMemberType {
  // Dubai
  MainPerson = 0, // Ana Başvuru Sahibi
  Wife = 1, // Eş
  Son = 2, // Oğul hem dubai hem saudi arabia için
  Daughter = 3, // Kız
  Father = 4, // Baba
  Mother = 5, // Anne
  Brother = 6, // Erkek Kardeş hem Dubai hem Saudi Arabia için

  // Saudi Arabia
  Husband = 7, // Koca
  Nephew = 8, // Yeğen
  Uncle = 9, // Amca
  FatherInLaw = 10, // Kayınpeder
  Uncle_Mother = 12, // Dayı
  Grandfather = 11, // Dede
  MotherInLaw = 13, // Kayınvalide
  SonInLaw = 14, // Damad
}
// Dubai 33
// Suudi 51
export const familyMemberTypeList = [
  { id: familyMemberType.MainPerson, name: 'Ana Başvuru Sahibi' },
  { id: familyMemberType.Wife, name: 'Eş', countryId: 33 },
  { id: familyMemberType.Son, name: 'Oğul' },
  { id: familyMemberType.Daughter, name: 'Kız', countryId: 33 },
  { id: familyMemberType.Father, name: 'Baba', countryId: 33 },
  { id: familyMemberType.Mother, name: 'Anne', countryId: 33 },
  { id: familyMemberType.Brother, name: 'Erkek Kardeş' },
  { id: familyMemberType.Husband, name: 'Koca', countryId: 51 },
  { id: familyMemberType.Nephew, name: 'Yeğen', countryId: 51 },
  { id: familyMemberType.Uncle, name: 'Amca', countryId: 51 },
  { id: familyMemberType.FatherInLaw, name: 'Kayınpeder', countryId: 51 },
  { id: familyMemberType.Uncle_Mother, name: 'Dayı', countryId: 51 },
  { id: familyMemberType.Grandfather, name: 'Dede', countryId: 51 },
  { id: familyMemberType.MotherInLaw, name: 'Kayınvalide', countryId: 51 },
  { id: familyMemberType.SonInLaw, name: 'Damat', countryId: 51 },
];
